import styled from 'styled-components';
import { useReportContext } from '../../context/DetailContext';
import { useEffect, useRef, useState } from 'react';
import { CaseInfo, RealSalesFilter } from './data';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import {
  AroundRealDealFilter,
  BasicInfoProps,
  HouseInfoProps,
  LandInfoProprs,
  RealDealFilter,
} from './data';
import DetailService from '../../service/detail';
import Summary from './components/summary/Summary';
import BasicInfo from './components/basicInfo/BasicInfo';
import BiddingHistory from './components/biddingHistory/BiddingHistory';
import BiddingMethodInfo from './components/biddingMethodInfo/BiddingMethodInfo';
import AfterBidInfo from './components/afterBidInfo/AfterBidInfo';
import BiddingInfo from './components/biddingInfo/BiddingInfo';
import ItemState from './components/ItemState/ItemState';
import { PAuctionAppraisalPrice } from './components/appraisalPrice/AppraisalPrice';
import { PTenantStatus } from './components/TenantStatus/TenantStatus';
import PRegisterStatus from './components/registerStatus/RegisterStatus';
import PriceAnalysis from './components/priceAnalysis/PriceAnalysis';
import AptComplexInfo from './components/AptComplexInfo';
import AiRecommendation, {
  DataProps,
} from './components/aiRecommendation/AiRecommendation';
import Menu from '../components/menu/Menu';
import PageToTop from './components/pageToTop';
import RelatedItemTab from './components/relatedItemTab';
import ScrollToTopButton from '../components/ScrollToTopButton';
import Loading from '../../func/components/loading/LoadingCircle';
import { NplCalculation } from '../../utils/nplAnalysis';
import { INplInfo } from '../../service/detail';
import NPLSummary from './components/nplAnalysis/nplSummary';
import OverView from './components/nplAnalysis/OverView';
import RealEstateStatus from './components/nplAnalysis/RealEstateStatus';
import SaleDateSimulation from './components/nplAnalysis/SaleDateSimulation';
import SeniorityDetails from './components/nplAnalysis/SeniorityDetails';
import ExpectedLoanPrincipal from './components/nplAnalysis/ExpectedLoanPrincipal';
import ExpectedInvestmentPeriod from './components/nplAnalysis/ExpectedInvestmentPeriod';
import ExpectedDividendAnalysis from './components/nplAnalysis/ExpectedDividendAnalysis';
import CostAnalysis from './components/nplAnalysis/CostAnalysis';
import ProfitAnalysis from './components/nplAnalysis/ProfitAnalysis';
import NPLNavigationTab from './components/nplAnalysis/nplAnalysisNavigationTab';
import { userGradeType } from '../../utils/auth';
import { useModal } from '../../context/ModalContext';
import PAttachmentFile from './PAttachmentFile';
import AttachmentFileModal from './AttachmentFileModal';
import { PFileList } from '../../sidebar';
import Footer from '../components/footer/Footer';
import DetailOrNplTab from './components/nplAnalysis/DetailOrNplTab';
import LoanInfoService from '../../service/LoanInfo';
import NearList from './components/aiRecommendation/NearList';
import DetailPageTop from '../components/pageTop/DetailPageTop';
import InterestSerivce from '../../service/Interest';
import Inquire from './components/Inquire';
import NavigationTab from './components/NavigationTab';
import DetailPageFooter from '../components/footer/DetailPageFooter';
import QuotaService from '../../service/quota/Quota';
import NearRealPrice from './components/priceAnalysis/NearRealPrice';
import NearRealSale from './components/priceAnalysis/NearRealSale';
import SameRealPrice from './components/priceAnalysis/SameRealPrice';
import SameRealSale from './components/priceAnalysis/SameRealSale';

interface fileProps {
  link: string;
  title: string;
}

const PAuctionDetail = () => {
  const { modalDispatch, modal } = useModal();

  const {
    type,
    setType,
    itemType,
    setItemType,
    setLat,
    setLng,
    setBid,
    setGeom,
    setZoning,
    iidx,
    setIidx,
    regionAccess,
    setRegionAccess,
    quotaAccess,
    setQuotaAccess,
  } = useReportContext();
  const navigate = useNavigate();
  const { number } = useParams();
  const [searchParams] = useSearchParams();
  const listType = searchParams.get('type');

  const [tab, setTab] = useState('pAuction');
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [nplQuotaAccess, setNplQuotaAccess] = useState(false);

  const [caseInfo, setCaseInfo] = useState<CaseInfo | null>(null);
  const [caseno, setCaseno] = useState('');
  const [imgList, setImgList] = useState([]);
  const [basicInfo, setBasicInfoData] = useState<BasicInfoProps>();
  const [landInfo, setLandInfo] = useState<LandInfoProprs>();
  const [houseInfo, setHouseInfo] = useState<HouseInfoProps>();
  const [saleInfo, setSaleInfoData] = useState();
  const [pRenterInfo, setPRenterInfo] = useState('');
  const [rentNote, setRentNote] = useState([]);
  const [registerStatus, setRegisterStatus] = useState();
  const [bidHistory, setBidHistory] = useState();
  const [bidMethod, setBidMethod] = useState();
  const [leaseinfo, setLeaseInfo] = useState();
  const [pAuctionAppraisalPriceInfo, setPAuctionAppraisalPriceInfo] =
    useState();
  const [link, setLink] = useState('');
  const [locationInfo, setLocationInfo] = useState('');
  const [appraisalevaluation, setAppraisalEvaluation] = useState('');
  const [realPriceData, setRealPriceData] = useState(); // 동일물건 실거래가
  const [sameAddressItems, setSameAddressItems] = useState<DataProps[]>([]);
  const [sameAddressItems2, setSameAddressItems2] = useState<DataProps[]>([]);
  const [linkSet, setLinkSet] = useState();
  const [subHouseInfo, setSubHouseInfo] = useState(); //총괄표제부
  const [groupCategory, setGroupCategory] = useState(''); //그룹카테고리 //A7일 때만 업빌드 나옴
  const [attachmentFile, setAttachmentFile] = useState<fileProps[]>([]);
  const [showFileModal, setShowFileModal] = useState(false);
  const [warning, setWarning] = useState();
  const [sameItemAddr, setSameItemAddr] = useState('');
  const [isTopButton, setIsTopButton] = useState(false);
  const [relatedItem, setRelatedItem] = useState();
  const [nplInfo, setNplInfo] = useState<INplInfo>();
  const [nplAnalysis, setNplAnalysis] = useState<NplCalculation>();
  const [viewInfo, setViewInfo] = useState(null);
  const [isLikeItem, setIsLikeItem] = useState(false); // 관심 여부

  const [countIdx, setCountIdx] = useState('');

  const [realDealFilter, setRealDealFilter] = useState<RealDealFilter>({
    iidx: Number(number) ?? 0,
    b_idx: 0,
    distance: 500,
    limit: 6,
    offset: 0,
  });

  const countView = async (iidx: string) => {
    try {
      const res = await LoanInfoService.viewCount(iidx);
      setCountIdx(res.data);
    } catch (e) {
      console.log(e);
    }
  };

  const callViewCountValid = async (countIdx: string) => {
    try {
      await LoanInfoService.viewCountValid(countIdx);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (!modal.userAlert.open && modal.userAlert.type !== null) {
      if (modal.userAlert.type === 'guest' && !modal.login) {
        if (window.history.length > 1) {
          navigate(-1);
        } else {
          window.close();
        }
      }
    }
  }, [modal.userAlert.open]);

  useEffect(() => {
    if (!countIdx) return;

    const intervalId = setInterval(() => {
      callViewCountValid(countIdx);
    }, 60 * 1000);

    return () => clearInterval(intervalId);
  }, [countIdx]);

  async function getNplData(iidx: number) {
    try {
      setLoading(true);

      const nplInfo = await DetailService.getNplAnalysis(iidx);

      setNplAnalysis(
        new NplCalculation(
          Number(nplInfo.appraisedprice),
          Number(nplInfo.claimAmount),
          nplInfo.stats,
          nplInfo.ai,
          nplInfo.sale_date.map((el) => ({ ...el, price: Number(el.price) })),
          nplInfo.bondPrice,
          nplInfo.court,
          nplInfo.seniorInfo,
          nplInfo.is_company,
          nplInfo.marketPrc,
        ),
      );
      setNplInfo(nplInfo);
    } catch (e) {
      setIsError(true);
      console.error('getNplData', e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (tab === 'npl' && iidx !== '' && !nplInfo) {
      getNplData(Number(iidx));
    }
  }, [tab, iidx, nplInfo]);

  /**총괄표제부에서 주용도지역인 객체의 건물명을 가져오는 함수 */
  const getOneNameWithSubHouseInfo = (arr: any[]): string | null => {
    const found = arr.find((item) => item.mainminorcodename === '주건축물');
    return found ? found.buildingname : '';
  };

  const getDetailData = async (iidx: number) => {
    setLoading(true);
    try {
      const res = await DetailService.detail(iidx);
      if (res.status === 'success') {
        if (res.data.regionAccess === undefined) {
          setRegionAccess(true);
        } else {
          setRegionAccess(res.data.regionAccess);
        }
        setGroupCategory(res.data.info.group_category);
        setType(res.data.info.caseInfo.type);
        setItemType(res.data.houseInfo ? 'H' : 'L');
        setCaseInfo(res.data.info.caseInfo);
        setImgList(res.data.info.imgs);
        setHouseInfo(
          res.data.houseInfo
            ? res.data.houseInfo[0]
            : { approvaldate: 'nodata' },
        );
        setLandInfo(
          res.data.landInfo ? res.data.landInfo[0] : { address: 'nodata' },
        );
        if (res.data.mapInfo && res.data.mapInfo.length > 0) {
          setLat(res.data.mapInfo[0].lat);
          setLng(res.data.mapInfo[0].lng);
          const wkt = res.data.mapInfo[0].geom;
          const coordinates = wkt
            .replace('MULTIPOLYGON(((', '') // WKT 헤더 제거
            .replace(')))', '') // 마지막 괄호 제거
            .split(',') // 좌표 문자열 분리
            .map((coord: any) => {
              const [lng, lat] = coord.trim().split(' ').map(Number);
              return [lng, lat]; // 배열 형식으로 변환
            });
          setGeom(coordinates);
        }
        setBasicInfoData(res.data.info.loanInfo[0]);
        setCaseno(res.data.info.caseInfo.caseno);
        setBid(res.data.info.caseInfo.bid);
        setSaleInfoData(res.data.info.info);
        setAttachmentFile(res.data.info.file);
        setRelatedItem(res.data.listOfUnitno);
        setLinkSet(res.data.link);
        if (res.data.pauction && res.data.pauction.length > 0) {
          setPRenterInfo(res.data.pauction[0].registrationcertificatekey);
          setRegisterStatus(res.data.pauction[0].bidmethod);
          setBidMethod(res.data.pauction[0].bidinformation);
          setLeaseInfo(res.data.pauction[0].leaseinformation);
          setBidHistory(res.data.pauction[0].nearbyauctionstatistics);
          setPAuctionAppraisalPriceInfo(
            res.data.pauction[0].afterbiddingdelivery,
          );
          setLink(res.data.pauction[0].link);
          setLocationInfo(res.data.pauction[0].locationandusagestatus);
          setAppraisalEvaluation(res.data.pauction[0].appraisalevaluation);
        }
        setSubHouseInfo(res.data.subHouseInfo);
        setWarning(res.data.warning);
        setSameItemAddr(
          res.data.houseInfo
            ? res.data.subHouseInfo.length > 0
              ? (getOneNameWithSubHouseInfo(res.data.subHouseInfo) ?? '')
              : ''
            : res.data.info.caseInfo.iaddr,
        );
        if (res.data.houseInfo) {
          setZoning(res.data.landInfo[0].zoning_backup ?? '');
        }
        setViewInfo(res.data.viewInfo);
      }
    } catch (error: any) {
      setIsError(true);
      console.error('API 오류:', error);
    } finally {
      setLoading(false);
    }
  };

  const getRealDealPriceList = async (data: RealDealFilter) => {
    try {
      const { iidx, b_idx, distance, limit, offset, is_same1, is_same2 } = data;
      const res = await DetailService.realDealPrice(
        iidx,
        b_idx,
        distance,
        limit,
        offset,
        is_same1,
        is_same2,
      );
      setRealPriceData(res.data);
    } catch (e) {
      console.log(e);
    }
  };
  //동일 물건 실거래가 조회
  useEffect(() => {
    if (iidx !== '') {
      getRealDealPriceList({ ...realDealFilter, iidx: Number(iidx) });
    }
  }, [iidx, realDealFilter]);

  const itemDetailLink = `/itemDetailPage?iidx=${caseInfo?.iidx}`;

  const GetList = async (iidx: number) => {
    try {
      const res = await DetailService.nearbyItems(iidx);
      setSameAddressItems(res.data.list1);
      setSameAddressItems2(res.data.list2);
    } catch (e) {
      console.log(e);
    }
  };

  // 서비스 이용권 사용
  const serviceQuota = async (type: string, iidx: number) => {
    try {
      const data = {
        type,
        iidx,
      };
      await QuotaService.use(data);
    } catch (err) {
      console.log(err, '발생');
    }
  };

  // 서비스 이용권 확인
  const getServiceQuotaCheck = async (type: string, iidx: number) => {
    try {
      const res = await QuotaService.check(type, iidx);

      return res.data;
    } catch (err) {
      console.log(err, '발생');
      return false;
    }
  };

  const DetailQuotaCheck = async () => {
    const res = await getServiceQuotaCheck('A', Number(iidx));
    setQuotaAccess(res);
  };

  const NPLQuotaCheck = async () => {
    const res = await getServiceQuotaCheck('C', Number(iidx));
    setNplQuotaAccess(res);
  };

  useEffect(() => {
    if (number) {
      setIidx(number);
    }
  }, [number]);

  useEffect(() => {
    if (iidx) {
      getDetailData(Number(iidx)); // 상세 정보
      GetList(Number(iidx)); // 동일 지번 물건
      countView(iidx); // 유효 조회수
      DetailQuotaCheck(); // 이용권 확인
      serviceQuota('A', Number(iidx)); // 이용권 사용
    }
  }, [iidx]);

  useEffect(() => {
    if (iidx && listType === 'b') {
      NPLQuotaCheck();
    }
  }, [iidx, listType]);

  const plusAnalysisYN = () => {
    if (itemType === 'H') {
      // '단독주택'일 경우 또는 '주택'이면서 HOUSEINFO.USE가 '단독주택'일 경우
      const validCategories = [
        '임야',
        '대지',
        '단독주택',
        '도시형생활주택',
        '기타주거용건물',
        '다가구주택',
        '조립식주택',
      ];
      const isValidBasicCategory = validCategories.includes(
        basicInfo?.category ?? '',
      );

      if (basicInfo?.category === '임야' || basicInfo?.category === '대지') {
        return true;
      } else if (
        isValidBasicCategory &&
        houseInfo?.mainpurposecodename === '단독주택'
      ) {
        return true;
      } else {
        return false;
      }
    }

    if (itemType === 'L') {
      const validCategories = [
        '전',
        '답',
        '과수',
        '과수원',
        '농지',
        '임야',
        '대지',
        '대',
      ];
      const isValidBasicCategory = validCategories.includes(
        basicInfo?.category ?? '',
      );
      const isValidLandCategory = validCategories.includes(
        landInfo?.category ?? '',
      );

      return isValidBasicCategory && isValidLandCategory;
    }

    return false;
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      if (scrollY > 50) {
        setIsTopButton(true);
      } else {
        setIsTopButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const checkIsLikeItem = async (iidx: number) => {
    try {
      const res = await InterestSerivce.check(iidx);
      setIsLikeItem(res.data.is_like);
    } catch (error) {
      console.error('checkIsLikeItem 함수에서 에러 발생:', error);
    }
  };

  useEffect(() => {
    if (caseInfo && caseInfo.iidx) {
      checkIsLikeItem(caseInfo.iidx);
    }
  }, [caseInfo, isLikeItem]);

  const summaryRef = useRef<HTMLDivElement>(null);
  const [isScrolledPastSummary, setIsScrolledPastSummary] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!summaryRef.current) return;
      const rect = summaryRef.current.getBoundingClientRect();
      setIsScrolledPastSummary(rect.bottom <= 56); // 헤더 높이 기준
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return (
    <Container>
      <DetailPageTop
        caseInfo={caseInfo}
        isScrolledPastSummary={isScrolledPastSummary}
        isLikeItem={isLikeItem}
        setIsLikeItem={setIsLikeItem}
        checkIsLikeItem={checkIsLikeItem}
      />
      <ScrollToTopButton />
      <DetailOrNplTab
        tab={tab}
        setTab={setTab}
        nplQuotaAccess={nplQuotaAccess}
      />
      {relatedItem && (
        <RelatedItemTab relatedItem={relatedItem} number={number} />
      )}
      {tab === 'pAuction' &&
        !isError &&
        (loading ? (
          <Loading />
        ) : (
          <Inner>
            {caseInfo && (
              <Summary
                caseInfo={caseInfo}
                imgList={imgList}
                basicInfo={basicInfo}
                realPriceData={realPriceData}
                landInfo={landInfo}
                viewInfo={viewInfo}
                ref={summaryRef}
                isLikeItem={isLikeItem}
                setIsLikeItem={setIsLikeItem}
                checkIsLikeItem={checkIsLikeItem}
              />
            )}

            <Inquire />

            <div>
              <NavigationTab />
              {basicInfo && (
                <BasicInfo
                  data={basicInfo}
                  linkSet={linkSet}
                  caseInfo={caseInfo}
                  assetDetailLink={itemDetailLink}
                />
              )}
            </div>
            {bidHistory && <BiddingHistory bidHistory={bidHistory} />}
            {bidHistory && <BiddingInfo bidHistory={bidHistory} />}
            {bidMethod && <BiddingMethodInfo bidMethod={bidMethod} />}
            {leaseinfo && <AfterBidInfo leaseinformation={leaseinfo} />}

            {/* 물건현황 */}
            {landInfo && houseInfo && (
              <ItemState
                subHouseInfo={subHouseInfo}
                landInfo={landInfo}
                houseInfo={houseInfo}
                appraisalevaluation={appraisalevaluation}
                locationInfo={locationInfo}
                groupCategory={groupCategory}
                caseInfo={caseInfo}
                linkSet={linkSet}
              />
            )}

            {/* 임차인현황 */}
            {pRenterInfo && rentNote && (
              <PTenantStatus pRenterInfo={pRenterInfo} rentNote={rentNote} />
            )}

            {/* 등기부 현황 */}
            {registerStatus && (
              <PRegisterStatus
                registerStatus={registerStatus}
                warning={warning}
                linkSet={linkSet}
              />
            )}

            {/* 감정가 */}
            {pAuctionAppraisalPriceInfo && (
              <PAuctionAppraisalPrice
                data={pAuctionAppraisalPriceInfo}
                link={link}
                linkSet={linkSet}
              />
            )}

            {/* 단지정보 */}
            <AptComplexInfo
              type="A"
              idx={Number(iidx)}
              setLinkSet={setLinkSet}
            />

            {/* 가격분석 */}
            <PriceAnalysis />

            {/* 동일 물건 */}
            {/* 실거래가 */}
            <SameRealPrice
              sameItemAddr={sameItemAddr}
              realPriceData={realPriceData}
              realDealFilter={realDealFilter}
              setRealDealFilter={setRealDealFilter}
            />
            {/* 매물가격 */}
            <SameRealSale sameItemAddr={sameItemAddr} />
            {/* 진행 물건 */}
            {sameAddressItems.length > 0 && (
              <AiRecommendation
                title="동일 지번 진행 물건"
                data={sameAddressItems}
                status="진행"
              />
            )}
            {/* 낙찰 물건 */}
            {sameAddressItems2.length > 0 && (
              <AiRecommendation
                title="동일 지번 낙찰 물건"
                data={sameAddressItems2}
                status="낙찰"
              />
            )}

            {/* 인근 물건 */}
            {/* 실거래가 */}
            <NearRealPrice />
            {/* 매물가격 */}
            <NearRealSale />
            {/* 진행 물건 */}
            <NearList
              iidx={iidx ?? ''}
              title="인근 반경 진행 물건"
              status="B"
              regionAccess={regionAccess}
            />
            {/* 낙찰 물건 */}
            <NearList
              iidx={iidx ?? ''}
              title="인근 반경 낙찰 물건"
              status="A"
              regionAccess={regionAccess}
            />

            {/* 첨부파일 */}
            <PAttachmentFile
              linkSet={linkSet}
              setShowFileModal={setShowFileModal}
            />
            {showFileModal && (
              <AttachmentFileModal
                showFileModal={showFileModal}
                setShowFileModal={setShowFileModal}
                attachmentFile={attachmentFile}
                linkSet={linkSet}
              />
            )}
          </Inner>
        ))}
      {tab === 'npl' &&
        !isError &&
        (loading ? (
          <Loading />
        ) : (
          <ReportContainer id="printable">
            <NPLNavigationTab />
            {caseInfo && nplAnalysis && nplInfo && (
              <ReportDetail>
                {/* NPL 분석요약 */}
                <div id="NPL 분석요약">
                  <NPLSummary
                    caseInfo={caseInfo}
                    summary={nplAnalysis.getSummary()}
                    info={nplInfo}
                  />
                </div>

                {/* 채권 내 물건별 개요 */}
                <div id="채권내 물건별 개요">
                  <OverView itemList={nplInfo.itemList} />
                </div>

                {/* 부동산 현황 */}
                <div id="부동산현황">
                  <RealEstateStatus info={nplInfo} />
                </div>

                {/* 매각기일 시뮬레이션 */}
                <div id="매각기일 시뮬레이션">
                  <SaleDateSimulation
                    bidDateSimulation={nplAnalysis.getBidDateSimul()}
                  />
                </div>

                {/* 선순위 내역 */}
                <div id="선순위내역">
                  <SeniorityDetails
                    seniorityDetails={nplAnalysis.getSeniorInfo()}
                  />
                </div>

                {/* 예상 대출원리금 */}
                <div id="예상대출원리금">
                  <ExpectedLoanPrincipal
                    expectedLoanPrincipal={nplAnalysis.getExpectedLoan()}
                  />
                </div>

                {/* 예상 투자기간 */}
                <div id="예상투자기간">
                  <ExpectedInvestmentPeriod
                    expectedInvestmentPeriod={nplAnalysis.getExpectedInvestmentDays()}
                  />
                </div>

                {/* 예상 배당분석 */}
                <div id="예상배당분석">
                  <ExpectedDividendAnalysis
                    expectedDividendAnalysis={nplAnalysis.getExpectedDividendAnalysis()}
                  />
                </div>

                {/* 비용 분석 */}
                <div id="비용분석">
                  <CostAnalysis
                    profitAnalysis={nplAnalysis.getProfitAnalysis()}
                  />
                </div>

                {/* 수익 분석 */}
                <div id="수익분석">
                  <ProfitAnalysis
                    revenueAnalysis={nplAnalysis.getRevenueAnalysis()}
                  />
                </div>
              </ReportDetail>
            )}
          </ReportContainer>
        ))}

      <DetailPageFooter />
    </Container>
  );
};

export default PAuctionDetail;

const Container = styled.div`
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  position: relative;
  overflow-x: clip;
`;
const Inner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: #f0f0f0;
`;

const ReportContainer = styled.div`
  width: 100%;
  background-color: #fff;
  font-family: Spoqa Han Sans Neo;
  position: relative;
  display: flex;
  flex-direction: column;
`;
const ReportDetail = styled.div`
  width: 100%;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
`;
